import React from 'react'
import { IApp } from './type'
import { Spinner } from '../../../helpers/commonUi'
import { AppCard } from './AppCard'
import style from './styles/marketplace-apps.module.css'

interface IProps {
  removeApp: (id: string) => void
  updateApp: (id: string, data: any) => void
  apps: IApp[]
  loading: boolean
}

export const AppContainer: React.FC<IProps> = ({
  apps,
  removeApp,
  loading,
  updateApp,
}) => {
  if (loading) {
    return <Spinner />
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-7 widget-container">
      {apps.map((app) => {
        return (
          <AppCard
            key={app.id}
            app={app}
            removeApp={removeApp}
            updateApp={updateApp}
          />
        )
      })}
    </div>
  )
}
